/* eslint-disable no-irregular-whitespace */
import { cloudfrontUrl } from '../constants/imageUrl';
import { Category, Product, SideByCategory } from '../types/product';

export const categories = Object.values(Category).map((category) => ({
  key: category,
  label: category,
}));

export const products: Product[] = [
  {
    id: 'signature-platter',
    name: 'Menu Truffle Chicken Burger',
    price: '19.5',
    category: Category.SIGATURE_PLATTER,
    description: `Édition Hiver - Burger au poulet à la truffe + Pommes noisette`,
    images: [`${cloudfrontUrl}/food/truffle_burger.png`],
    isVisible: true,
  },
  {
    id: 'seoul-burger',
    name: 'SEOUL BURGER',
    price: '14.5',
    category: Category.BURGER,
    description: `Hauts de cuisse de poulet désossés, assaisonnés de notre mélange d’épices secret,
cuits dans de l’huile de tournesol 100 % raffinée et servis dans un pain grillé beurré, avec des cornichons et la sauce KSM Sweet Mayonnaise.
`,
    images: [`${cloudfrontUrl}/food/classic_chicken_burger.png`],
    isVisible: true,
  },
  {
    id: 'fire-chicken-burger',
    name: 'FIRE CHICKEN BURGER',
    price: '15.5',
    category: Category.BURGER,
    description: `Un burger de poulet frit authentiquement coréen, accompagné d’une combinaison de sauce KSM Spicy, de sauce authentique épicée et de nos piments frits.
`,
    images: [`${cloudfrontUrl}/food/yangnyeom_chicken_burger.png`],
    isVisible: true,
  },
  {
    id: 'bbq-burger',
    name: 'BBQ BURGER',
    price: '15.5',
    category: Category.BURGER,
    description: `Inspiré du plat coréen Tonkatsu. Hauts de cuisse de poulet désossés, panés avec une chapelure coréenne.
Servis avec une combinaison de sauce spéciale Namsan BBQ et de sauce KSM rosée au poivre.`,
    images: [`${cloudfrontUrl}/food/katsu_burger.png`],
    isVisible: true,
  },
  {
    id: 'crab-wasabi-burger',
    name: 'CRAB WASABI BURGER',
    price: '15.5',
    category: Category.BURGER,
    description: `Hauts de cuisse de poulet désossés, assaisonnés de notre mélange d’épices secret, panés et frits dans de l’huile de tournesol 100 % raffinée, servis dans un pain brioché grillé au beurre, avec des cornichons, une salade de crabe onctueuse et notre sauce signature KSM Sweet Wasabi Mayonnaise.`,
    images: [
      `${cloudfrontUrl}/food/ksmweb_crab_wasabi_burger (1).png`,
      `${cloudfrontUrl}/food/15012026-DSC06580.jpg`,
      `${cloudfrontUrl}/food/15012026-DSC06577.jpg`,
      `${cloudfrontUrl}/food/15012026-DSC06579.jpg`,
    ],
    isVisible: true,
  },
  {
    id: 'lovely-pink-burger',
    name: 'Lovely Pink Burger',
    price: '15.5',
    category: Category.BURGER,
    description: `Un burger qui change la donne, visuellement audacieux et incroyablement savoureux. Un pain bun rose tendre qui capte le regard, garni d’ingrédients soigneusement sélectionnés pour une explosion de textures et de goûts à chaque bouchée.

À l’intérieur, une oignon blanc doucement relevé par une sauce au poivre, crémeuse et piquante juste ce qu’il faut, vient envelopper une côte de chou rouge croquante qui apporte fraîcheur, couleur et un contraste parfait. L’ensemble est un équilibre entre douceur, caractère et fraîcheur — un burger aussi photogénique que délicieux.

Couleurs, textures et saveurs s’assemblent pour faire vibrer ton palais. Lovely Pink Burger : une expérience gustative qui s’affirme dès le premier regard.`,
    images: [
      `${cloudfrontUrl}/food/260212_KSM_burger_valentine.png`,
      `${cloudfrontUrl}/food/pink-burger-menu.jpg`,
    ],
    isVisible: true,
  },
  {
    id: 'seoul-corndog',
    name: 'SEOUL CORNDOG',
    price: '7',
    category: Category.CORNDOG,
    description: `Le corn dog authentique de Corée, alliant saveurs sucrées et salées.`,
    images: [`${cloudfrontUrl}/food/corndog_classic2.png`],
    isVisible: true,
  },
  {
    id: 'seoul-potato-corndog',
    name: 'SEOUL POTATO CORNDOG',
    price: '8.0',
    category: Category.CORNDOG,
    description: `Le corn dog authentique de Corée, mélange de saveurs sucrées et salées,
enveloppé de cubes de pommes de terre.`,
    images: [`${cloudfrontUrl}/food/potato_corndog_classic2.png`],
    isVisible: true,
  },
  {
    id: 'spicy-corndog',
    name: 'SPICY CORNDOG',
    price: '7.5',
    category: Category.CORNDOG,
    description: `Une combinaison de sauce KSM Spicy, de sauce authentique épicée et de notre poudre épicée signature.`,
    images: [`${cloudfrontUrl}/food/corndog_spicy2.png`],
    isVisible: true,
  },
  {
    id: 'spicy-potato-corndog',
    name: 'SPICY POTATO CORNDOG',
    price: '8.5',
    category: Category.CORNDOG,
    description: `Une combinaison de sauce KSM Spicy, de sauce authentique épicée et de notre poudre épicée signature,
enveloppé de cubes de pommes de terre.`,
    images: [`${cloudfrontUrl}/food/potato_corndog_spicy.png`],
    isVisible: true,
  },
  {
    id: 'cheese-corndog',
    name: 'CHEESE CORNDOG',
    price: '7.5',
    category: Category.CORNDOG,
    description: `Saupoudré de notre assaisonnement signature KSM et servi avec des sauces fromagères.`,
    images: [`${cloudfrontUrl}/food/corndog_cheese2.png`],
    isVisible: true,
  },
  {
    id: 'cheese-potato-corndog',
    name: 'CHEESE POTATO CORNDOG',
    price: '8.5',
    category: Category.CORNDOG,
    description: `Saupoudré de notre assaisonnement signature KSM et servi avec des sauces fromagères,
enveloppé de cubes de pommes de terre.`,
    images: [`${cloudfrontUrl}/food/potato_corndog_cheese2.png`],
    isVisible: true,
  },
  {
    id: 'golden-chicken',
    name: 'GOLDEN CHICKEN',
    price: '15.9',
    category: Category.CHICKEN,
    description: `Notre plat ADN signature. Hauts de cuisse de poulet désossés, assaisonnés de notre mélange d’épices secret,
cuits dans de l’huile de tournesol 100 % raffinée.
Un goût simple mais parfait, avec une texture croustillante et juteuse, accompagné de nos 3 sauces signature KSM.`,
    images: [
      `${cloudfrontUrl}/food/chicken.png`,
      `${cloudfrontUrl}/food/chicken2.png`,
    ],
    isVisible: true,
  },
  {
    id: 'snow-onion-golden-chicken',
    name: 'SNOW ONION GOLDEN CHICKEN',
    price: '15.9',
    category: Category.CHICKEN,
    description: `Le Snow Onion Golden Chicken est la nouvelle définition du burger croustillant & savoureux. Il combine un poulet parfaitement doré et ultra-croquant avec une sauce onion pepper relevée, une pluie d’oignons frits et un assaisonnement oignon soigneusement équilibré. Une expérience gourmande, puissante et addictive à chaque bouchée.`,
    images: [`${cloudfrontUrl}/food/snow_golden-chicken (1).png`],
    isVisible: true,
  },
  {
    id: 'sweet-chili-chicken',
    name: 'SUPREME GOLDEN CHICKEN',
    price: '15.9',
    category: Category.CHICKEN,
    description: `Le Sweet Chili Chicken est une interprétation coréenne iconique du poulet enrobé de sauce. Inspirée du gochujang, cette recette mise sur une sauce brillante, nappante, équilibrée par une mayonnaise douce et des notes sucrées-salées légèrement fromagées. Gourmand, réconfortant et intensément addictif.`,
    images: [`${cloudfrontUrl}/food/spicy_golden_chicken (1).png`],
    isVisible: true,
  },
  {
    id: 'kimchi-coleslaw',
    name: 'COLESLAW DE KIMCHI',
    price: '',
    category: Category.SIDE,
    description:
      'Une délicieuse version revisitée de la salade de chou classique, combinée avec du kimchi.',
    images: [`${cloudfrontUrl}/food/coleslaw_au_kimchi.png`],
    isVisible: false,
  },
  {
    id: 'tteokbokki',
    name: 'TTEOKBOKKI',
    price: '6',
    category: Category.SIDE,
    description: `Le Tteokbokki, street food emblématique coréenne : petits gâteaux de riz gluant servis dans une sauce sucrée-salée et piquante.`,
    images: [`${cloudfrontUrl}/food/Tteokbokki.png`],
    isVisible: true,
  },
  {
    id: 'home-made-matchsticks-fries',
    name: 'FRITES ALLUMETTE MAISON',
    price: '5',
    category: Category.SIDE,
    description: `Une harmonie de croustillant et de moelleux, selon la recette spéciale de KSM.
`,
    images: [`${cloudfrontUrl}/food/frites_maison.png`],
    isVisible: true,
  },
  {
    id: 'bulgogi-fried-rice',
    name: 'RIZ SAUTE AU BULGOGI',
    price: '7',
    category: Category.SIDE,
    description: `Un goût de BBQ coréen, sublimé par la douceur de la pomme de terre.
`,
    images: [`${cloudfrontUrl}/food/riz_saute_au_bulgogi.png`],
    isVisible: true,
  },
  {
    id: 'sesame-oil-taboule',
    name: "TABOULE A L'HUILE DE SESAME",
    price: '7',
    category: Category.SIDE,
    description: `Un taboulé oriental relevé d’une touche coréenne.`,
    images: [`${cloudfrontUrl}/food/riz_saute_au_bulgogi2.png`],
    isVisible: true,
  },
  {
    id: 'salade-egg-potato',
    name: "SALADE D'OEUFS ET POMMES DE TERRE",
    price: '7',
    category: Category.SIDE,
    description: `Une salade de pommes de terre crémeuse et savoureuse, agrémentée d’œuf.`,
    images: [`${cloudfrontUrl}/food/taboule_a_l_huile_de_sesame.png`],
    isVisible: true,
  },
  {
    id: 'mini-vegetable-pancakes',
    name: 'MINI GALETTE DE LEGUMES COREENNE',
    price: '',
    category: Category.SIDE,
    description: `Une galette de légumes traditionnelle coréenne.
`,
    images: [`${cloudfrontUrl}/food/mini_galettes_de_legumes.png`],
    isVisible: true,
  },
  // Cocktails
  {
    id: 'jujube-nut-coke',
    name: 'JUJUBE NUT COKE',
    price: '8',
    category: Category.COCKTAIL,
    description: `Un twist coréen du Jack & Coke, infusé au jujube (datte coréenne) et aux pignons de pin.
Rond, légèrement sucré et subtilement boisé.`,
    images: [`${cloudfrontUrl}/food/jujube.png`],
    isVisible: true,
  },
  {
    id: 'omija-margarita',
    name: 'OMIJA MARGARITA',
    price: '8',
    category: Category.COCKTAIL,
    description: `Une margarita revisitée avec du vin d’omija (baie aux cinq saveurs).
Fraîche, acidulée et parfaitement équilibrée entre douceur et vivacité.`,
    images: [`${cloudfrontUrl}/food/margarita.png `],
    isVisible: true,
  },
  {
    id: 'yuzu-fruity',
    name: 'YUZU FRUITY',
    price: '8',
    category: Category.COCKTAIL,
    description: `Cocktail fruité à base de liqueur de yuzu, aux notes de pomme.
Léger, aromatique et très rafraîchissant.`,
    images: [`${cloudfrontUrl}/food/Yuzu.png`],
    isVisible: true,
  },
  {
    id: 'omija-highball',
    name: 'OMIJA HIGHBALL',
    price: '8',
    category: Category.COCKTAIL,
    description: `Un highball élégant à base de vin d’omija, allongé et pétillant.
Frais, peu sucré et idéal à l’apéritif.`,
    images: [`${cloudfrontUrl}/food/highball.png`],
    isVisible: true,
  },
  {
    id: 'sanmeoru-spritz',
    name: 'SANMEORU SPRITZ',
    price: '8',
    category: Category.COCKTAIL,
    description: `Un spritz original à base de vin coréen de sanmeoru (raisin sauvage).
Fruité, légèrement tannique, avec une touche festive et moderne.`,
    images: [`${cloudfrontUrl}/food/Spirits.png`],
    isVisible: true,
  },
  // Soju & Beer
  {
    id: 'soju-biere',
    name: 'SOMAC (SOJU + BIÈRE)',
    price: '8',
    category: Category.COCKTAIL,
    description: `Mélange emblématique coréen de bière et de soju, frais et facile à boire, très apprécié avec la street food coréenne.`,
    images: [
      `${cloudfrontUrl}/food/somac.png`,
      `${cloudfrontUrl}/food/somac1.png`,
    ],
    isVisible: true,
  },
  {
    id: 'terra-bière',
    name: 'TERRA BIÈRE',
    price: '6',
    category: Category.COCKTAIL,
    description: `Bière coréenne légère et rafraîchissante, au goût net et équilibré, idéale pour accompagner nos plats frits.`,
    images: [`${cloudfrontUrl}/food/beer.png`],
    isVisible: true,
  },
  {
    id: 'matcha-strawberry-latte',
    name: 'MATCHA STRAWBERRY LATTE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `L'alliance du matcha riche et des fraises sucrées vous apportera du bonheur.`,
    images: [`${cloudfrontUrl}/food/ksmweb_matchastrawberrylatte.png`],
    isVisible: true,
  },
  {
    id: 'matcha-chocolate-latte',
    name: 'MATCHA CHOCOLAT LATTE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Le matcha et le chocolat forment une association très appréciée. L'ajout de chocolat sucré au matcha le rend encore plus délicieux.`,
    images: [`${cloudfrontUrl}/food/ksmweb_chocomatchalatte.png`],
    isVisible: true,
  },
  {
    id: 'matcha-latte',
    name: 'MATCHA LATTE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Savourez le goût doux-amer du matcha ! Il vous offre la véritable saveur du matcha.`,
    images: [`${cloudfrontUrl}/food/ksmweb_matchalatte.png`],
    isVisible: true,
  },

  {
    id: 'fraise-latte',
    name: 'FRAISE LATTE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Des fraises sucrées et du lait ! Que dire de plus ? `,
    images: [`${cloudfrontUrl}/food/ksmweb_fraiselatte.png`],
    isVisible: true,
  },
  {
    id: 'milk-shake',
    name: 'MILK SHAKE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Savourez un milkshake sucré, rafraîchissant et onctueux !`,
    images: [`${cloudfrontUrl}/food/ksmweb_milkshake.png`],
    isVisible: true,
  },
  {
    id: 'mango-blended',
    name: 'MANGO BLENDED',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Découvrez le vrai goût de la mangue sucrée et riche !`,
    images: [`${cloudfrontUrl}/food/ksmweb_mangoblended.png`],
    isVisible: true,
  },
  {
    id: 'strawberry-blended',
    name: 'STRAWBERRY BLENDED',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Savourez le goût riche et frais des fraises !`,
    images: [`${cloudfrontUrl}/food/ksmweb_strawberryblended.png`],
    isVisible: true,
  },
  {
    id: 'rose-mango-ade',
    name: 'ROSE MANGO ADE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Le goût de la mangue fraîche et du citron acidulé vous transportera en été.`,
    images: [`${cloudfrontUrl}/food/ksmweb_mangoroseade.png`],
    isVisible: true,
  },
  {
    id: 'strawberry-lemon-ade',
    name: 'STRAWBERRY LEMON ADE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `L'alliance de la saveur authentique des fraises et du goût rafraîchissant du citron est désaltérante et se marie parfaitement avec tous les plats.`,
    images: [`${cloudfrontUrl}/food/ksmweb_strawberrylemonade.png`],
    isVisible: true,
  },
  {
    id: 'yuzu-matcha-ade',
    name: 'YUZU MATCHA ADE',
    price: '6',
    category: Category.MATCHA_SMOOTHIE,
    description: `Une combinaison rafraîchissante de yuzu sucré et de matcha amer ! Savourez ce goût sucré-amer que tout le monde adore.`,
    images: [`${cloudfrontUrl}/food/ksmweb_matchayuzuade.png`],
    isVisible: true,
  },
  {
    id: 'glace-matcha',
    name: 'GLACE AU MATCHA',
    price: '5',
    category: Category.DESSERT,
    description: `Une glace onctueuse et sucrée au bon goût de matcha !`,
    images: [`${cloudfrontUrl}/food/ksmweb_glace_matcha.png`],
    isVisible: true,
  },
  {
    id: 'glace-sunda-lait',
    name: 'GLACE SUNDAE AU LAIT',
    price: '5',
    category: Category.DESSERT,
    description: `Une glace onctueuse et sucrée au bon goût de lait ! Le dessert préféré de tous.`,
    images: [`${cloudfrontUrl}/food/ksmweb_glace_lait.png`],
    isVisible: true,
  },
];

export const sideByCategory: SideByCategory = {
  [Category.SIGATURE_PLATTER]: {
    description: `Plat signature aux saveurs coréennes : un voyage gourmand où se mêlent épices, textures et couleurs, à savourer en duo, comme un véritable rituel de convivialité.
    6 PIECES DE POULET
    GURAN-ZZIM
    BANCHAN: Radis mariné/Kimchi de carotte/Oignons marinés
    NOUILLES CAPELLINI AU SESAME Sauvage
    2 MINI BURGURS MAISON`,
    cold: [],
    hot: [],
  },
  [Category.CORNDOG]: {
    description:
      "Corndogs maison, symbole de la street-food coréenne : saucisse de poulet enrobée d'une pâte artisanale, frits minute pour un croustillant doré et gourmand.",
    cold: ['kimchi-coleslaw', 'sesame-oil-taboule', 'salade-egg-potato'],
    hot: [
      'home-made-matchsticks-fries',
      'mini-vegetable-pancakes',
      'tteokbokki',
    ],
  },
  [Category.BURGER]: {
    description:
      'Burgers signature, entre pain artisanal et poulet mariné croustillant à cœur, sublimés sauces originales, toutes élaborées maison.',
    cold: ['kimchi-coleslaw', 'sesame-oil-taboule', 'salade-egg-potato'],
    hot: [
      'home-made-matchsticks-fries',
      'mini-vegetable-pancakes',
      'tteokbokki',
    ],
  },
  [Category.CHICKEN]: {
    description:
      "Trois pièces de cuisse poulet fermier et desossés, marinés avec soin et enrobés d'une panure maison, frits minute pour un croustillant doré et une saveur unique.",
    cold: ['kimchi-coleslaw', 'sesame-oil-taboule', 'salade-egg-potato'],
    hot: [
      'home-made-matchsticks-fries',
      'mini-vegetable-pancakes',
      'tteokbokki',
    ],
  },
  [Category.SIDE]: {
    description: `Entrées revisitées, inspirées des saveurs coréennes et pensées pour les petites faims :
des bouchees creatives et gourmandes a déguster seules ou a partager.`,
    cold: [],
    hot: [],
  },
  [Category.COCKTAIL]: {
    description: `Découvrez un cocktail qui vous fera goûter de la vraie Corée. De Sans alcool a mocktail, choisissez parmi une variété de cocktails pour vous mettre en appétit.`,
    cold: [],
    hot: [],
  },
  [Category.MATCHA_SMOOTHIE]: {
    description: `Nous vous présentons une boisson à la fois familière et inédite. Nous proposons une variété de saveurs coréennes, dont un délicieux matcha et un riche sésame noir, tous préparés en Corée.`,
    cold: [],
    hot: [],
  },
  [Category.DESSERT]: {
    description: `Savourez une glace au goût riche, délicieuse après un repas ou tout simplement nature.`,
    cold: [],
    hot: [],
  },
};
